import { EntryKind } from "../../../model/entry/types/EntryKind.enum";

/** The kinds a single entry of `currentKind` may be converted to. */
export function getAvailableKindUpdateOptions(
  currentKind: EntryKind,
): EntryKind[] {
  switch (currentKind) {
    case EntryKind.LEAD:
      return [EntryKind.CONTACT, EntryKind.JUNK];
    case EntryKind.CONTACT:
      return [EntryKind.JUNK, EntryKind.LEAD];
    case EntryKind.JUNK:
      return [EntryKind.CONTACT];
    default:
      return [];
  }
}

/**
 * The kinds every one of `currentKinds` may be converted to together - the
 * intersection of each kind's own options. Empty when the selection has no
 * kind in common (e.g. a contact and a junk entry), and for an empty
 * selection.
 */
export function getBulkAvailableKindUpdateOptions(
  currentKinds: EntryKind[],
): EntryKind[] {
  const [first, ...rest] = Array.from(new Set(currentKinds));

  if (!first) {
    return [];
  }

  return rest.reduce(
    (options, kind) =>
      options.filter((option) =>
        getAvailableKindUpdateOptions(kind).includes(option),
      ),
    getAvailableKindUpdateOptions(first),
  );
}
